export enum EExerciseView {
  // non exercise view
  None = 'none',
  // exercise intro screen
  Intro = 'intro',
  // modes selection screen
  Modes = 'modes',
  // mode not implemented view (fake door experiment, see BW-5386)
  NotImplemented = 'not-impelemented',
  // actual workout view
  Workout = 'workout',
  // post-workout celebration (see achievements epic)
  Celebration = 'celebration',
  // post-exercise evaluation
  Evaluation = 'evaluation',
  // post-session evaluation
  Session = 'session',
  // post first session
  FirstSessionFinished = 'first-session-finished',
  // challenge workout finished
  ChallengeExerciseCompleted = 'challenge-exercise-completed',
}

export const unityPreloaderLottie = 'brain_in';
export const ledConfirmationLottie = 'BT_LED_confirm';
export const ledIncreaseDifficultyLottie = 'BT_LED_easy';
export const ledDecreaseDifficultyLottie = 'BT_LED_hard';

export enum ELedView {
  // do not render screen
  None = 'none',
  // show change confirmation screen
  Confirmation = 'confirmation',
  // show increase difficulty view
  Increase = 'increase',
  // show decrease difficulty view
  Decrease = 'decrease',
  // hide screen after beeing shown
  Hide = 'hide',
}

export enum EExerciseMode {
  Training = 'training',
  Learning = 'learning',
}

export const WORKOUTS_SUPPORTING_EXERCISE_RUN = [140, 240, 340, 141, 241, 341];
